export default __webpack_public_path__ + "static/media/dishant.90a83c42.jpg";